<div class="au-native-input-container">
	<mat-icon class="left-icon" svgIcon="search"></mat-icon>
	<input
		class="au-input-element"
		[formControl]="control"
		[placeholder]="placeholder"
		(keydown)="inputKeyDown.emit($event)"
		(focusin)="inputFocusIn()"
		(focusout)="inputFocusOut()"
	/>
	@if (control?.value) {
		<mat-icon
			class="right-icon"
			svgIcon="filled-cancel"
			(click)="clearHandler()"
		></mat-icon>
	}
</div>
